module.exports = __webpack_public_path__ + "static/img/pic6-1.0e886ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zt/pic6-1.jpg
// module id = 8R+r
// module chunks = 1